import { getBridgeSdk } from "./bridgeSdk";

export const getReloadUrlForLogin = () => {
    const origin = window.location.origin;
    const search = window.location.search;
    const pathname = window.location.pathname;
    // NextJS is removing .html when inserting custom_back queryParam hence need to check and reinsert it to redirectUrl
    // pathname = checkAndInsertHTML && !pathname.includes(".html") ? `${pathname}.html` : pathname;
    // eslint-disable-next-line no-console
    return `${origin}${pathname}${search}`;
};

export const handleLogin = async () => {
    try {
        await getBridgeSdk().login({
            reloadUrl: getReloadUrlForLogin(),
        });
    } catch {
        // Silently handle error
    }
};
